import { watch } from 'vue';

/**
 * Watches a search ref and calls the callback after a debounce delay.
 * Also handles clear (empty string) immediately.
 *
 * @param {import('vue').Ref<string>} searchRef - reactive search string
 * @param {Function} callback - function to call when search changes
 * @param {number} [delay=400] - debounce delay in milliseconds
 */
export function useDebounceSearch(searchRef, callback, delay = 400) {
  let timer = null;

  watch(searchRef, (value) => {
    if (timer) {
      clearTimeout(timer);
    }

    if (value === '' || value === null) {
      callback(value);
      return;
    }

    timer = setTimeout(() => {
      callback(value);
    }, delay);
  });
}
